import { useState } from "react"
import PropTypes from "prop-types"

import "./upsell.scss"
import UpgradePlanModal from "app/components/upgrade_plan_modal"

export default function Upsell({
  extraClass,
  proPlusProductId,
  proPlusSubscriptionUrl,
  proSubscriptionUrl,
  subscriptionPaymentType,
  tier,
  trialing,
}) {
  if (["pro", "legacy_pro"].includes(tier)) {
    return ""
  }

  const [showModal, updateShowModal] = useState(false)

  let copy = "Get Pro to get 20 Applets"
  let link = proSubscriptionUrl
  let object_id = "pro_link"
  let tierRequirement = "intermediate_pro"

  if (tier === "intermediate_pro") {
    copy = "Get Pro+ for unlimited Applets"
    link = proPlusSubscriptionUrl
    object_id = "pro_plus_link"
    tierRequirement = "pro"
  }

  const handleOnClick = e => {
    if (tier === "intermediate_pro") {
      e.preventDefault()
      updateShowModal(true)
    }
  }
  return (
    <>
      <a
        href={link}
        onClick={handleOnClick}
        data-track-ifttt-next-event="click"
        data-track-data={JSON.stringify({
          object_id,
          object_type: "pro_upsell",
          location_type: "my_applets",
        })}
        className="link-standalone"
        styleName={`pro-upsell ${extraClass}`}
      >
        {copy}
      </a>
      {tier === "intermediate_pro" && (
        <UpgradePlanModal
          appletFeatureFlags={false}
          onClose={() => updateShowModal(false)}
          onUpgrade={() => {
            window.appendFlash("Upgrade complete. Welcome to IFTTT Pro!", "success", () => window.location.reload())
          }}
          proPlusProductId={proPlusProductId}
          step="applet_quota"
          trackLocationType="my_applets"
          tierRequirement={tierRequirement}
          urls={{
            newProSubscriptionUrl: proSubscriptionUrl,
            newProPlusSubscriptionUrl: proPlusSubscriptionUrl,
          }}
          user={{
            eligibleForTrial: false,
            isTrialing: trialing,
            subscriptionPaymentType,
            tier,
          }}
          visible={showModal}
        />
      )}
    </>
  )
}

Upsell.propTypes = {
  extraClass: PropTypes.string,
  proPlusSubscriptionUrl: PropTypes.string.isRequired,
  proPlusProductId: PropTypes.string.isRequired,
  proSubscriptionUrl: PropTypes.string.isRequired,
  subscriptionPaymentType: PropTypes.string,
  tier: PropTypes.string.isRequired,
  trialing: PropTypes.bool.isRequired,
}

Upsell.defaultProps = {
  extraClass: "",
}
